import { useEffect } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { isAuthenticated } from '@/lib/auth.js';
import { endSession } from '@/lib/session.js';

export default function RequireAuth({ children }) {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    function onAuthExpired() {
      // The token and the SW's per-URL API cache go together (personal-logins m14).
      endSession();
      const returnTo = encodeURIComponent(location.pathname + location.search);
      navigate(`/login?return=${returnTo}`, { replace: true });
    }
    window.addEventListener('auth:expired', onAuthExpired);
    return () => window.removeEventListener('auth:expired', onAuthExpired);
  }, [location.pathname, location.search, navigate]);

  if (!isAuthenticated()) {
    const returnTo = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?return=${returnTo}`} replace />;
  }
  return children;
}
